import { useState, useCallback } from "react";

/**
 * Custom hook for managing modal state and copy functionality
 */
export const useScheduleModal = () => {
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [showInfoWindow, setShowInfoWindow] = useState(false);
  const [copyButtonText, setCopyButtonText] = useState("Copy Location Link");
  const [isCopying, setIsCopying] = useState(false);

  // Handle marker click
  const handleMarkerClick = useCallback((schedule) => {
    setSelectedSchedule(schedule);
    setShowInfoWindow(true);
  }, []);

  // Close info window
  const closeInfoWindow = useCallback(() => {
    setShowInfoWindow(false);
    setSelectedSchedule(null);
    setCopyButtonText("Copy Location Link");
    setIsCopying(false);
  }, []);

  // Copy location link function
  const copyLocationLink = useCallback(async () => {
    if (!selectedSchedule || !selectedSchedule.location) return;

    const { latitude, longitude, name } = selectedSchedule.location;
    let mapsUrl;

    if (latitude && longitude) {
      // Use coordinates for precise location
      mapsUrl = `https://maps.google.com/maps?q=${latitude},${longitude}`;
    } else {
      // Fallback to location name
      mapsUrl = `https://maps.google.com/maps?q=${encodeURIComponent(
        name || "Location"
      )}`;
    }

    try {
      setIsCopying(true);
      await navigator.clipboard.writeText(mapsUrl);
      setCopyButtonText("Copied!");

      // Reset after 2 seconds
      setTimeout(() => {
        setCopyButtonText("Copy Location Link");
        setIsCopying(false);
      }, 2000);
    } catch (err) {
      console.error("Failed to copy location link:", err);
      setCopyButtonText("Copy failed");
      setTimeout(() => {
        setCopyButtonText("Copy Location Link");
        setIsCopying(false);
      }, 2000);
    }
  }, [selectedSchedule]);

  return {
    selectedSchedule,
    showInfoWindow,
    copyButtonText,
    isCopying,
    handleMarkerClick,
    closeInfoWindow,
    copyLocationLink,
  };
};
